<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Office of the Secretary General 📝</h1>
        <h4>The Office of the Secretary-General is responsible for streamlining the organization’s operations, establishing the documentation (i.e. minutes of the meeting, organizational reports) and record-keeping procedures (i.e. good documentation practices), and ensuring that all internal procedures (i.e. Cluster Code of Internal Procedures of the Organization) & the Constitution are properly observed by the organization. The Office of the Secretary-General is also responsible for conducting investigations on issues concerning the organization’s members and officers.</h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>
 
        <h2><b>OSG Officer</b></h2>
        <h4>All OSG Officers rotate between all 5 clusters and 1 office (and experience to be in at least 2-3 clusters) to allow each officer to be well-versed in the processes of each cluster. Each officer will be assigned to a specific cluster for a period of 1-2 months depending on the OSG BETA’s discretion in aligning the rotation period to MISA’s calendar of events.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>An OSG officer works closely with the Associate Secretary-Generals in the following tasks:
                <ul>
                    <li>Takes the minutes of the meeting of their assigned cluster/office</li>
                    <li>Documenting the performance of their assigned cluster/office through monthly reports and town hall presentations </li>
                    <li>Communicating between offices </li>
                    <li>Preparing the org-wide newsletter </li>
                </ul>
            </li>
            <li> If assigned to a project of the Events Cluster, they will function as an <b>Operations Manager</b> who will be responsible for the following tasks:
              <ul>
                    <li>Gathers all documents pertinent to their assigned project (e.g. contract of project completion, project summary, and other relevant documents)</li>
                    <li>Takes minutes of the meeting and checks project team attendance</li>
                    <li>Handles BETA presentation material and manages event registration / RSVPs</li>
                    <li>Prepares, conducts, and summarizes project evaluations</li>
                    <li>Reminds team members of their deliverables and ensures the project team’s adherence to their deadlines</li>
                    <li>Notifies their assigned OSG associate in case of problems with their assigned project</li>
                </ul>
            </li>
        </ul>

        <h2><b>Data Analytics Officer (DAO)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li><u>Project Insights:</u> conduct data analytics and make data visualizations of different form responses and evaluations in order to suggest improvements and help make data-driven decisions</li>
            <li><u>Growth Management:</u> conduct data analytics and make data visualizations of social media engagement for MISA’s pages</li>
            <li><u>Transparency:</u> gather data amongst different clusters for transparency reports and processing</li>
        </ul>

        <h2><b>Operations Manager</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Gathers all documents pertinent to their assigned event (e.g. contract of project completion, project summary, and other relevant documents)</li>
            <li>Takes minutes of the meeting and checks project team attendance</li>
            <li>Handles BETA presentation material and manages event registration / RSVPs</li>
            <li>Prepares, conducts, and summarizes project evaluations and makes recommendations based off of these</li>
            <li>Conducts post-project SWOT analysis with other members of the core team</li>
            <li>Reminds team members of their deliverables and ensures the project team’s adherence to their deadlines</li>
            <li>Notifies their assigned OSG associate in case of problems with their assigned project</li>
        </ul>

        <!-- BETA POSITIONS -->
        <!-- <h2><b>OET Associate Secretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the OET as their intermediary</li>
            <li>Takes the minutes of the meeting of the OET BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the OET, and reports any violation thereof</li>
            <li>Ensures proper documentation of the OET’s procedures and helps the Executive Treasurer in dealing with contingencies</li>
            <li>In charge of evaluating the initiatives and operations in the Communications Cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul>

        <h2><b>Communications Associate Seretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the Communications Cluster as their intermediary</li>
            <li>Takes the minutes of the meeting of the Communications Cluster BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the Communications Cluster, and reports any violation thereof</li>
            <li>Ensures proper documentation of the Communications Cluster’s procedures and helps the Communications VP in dealing with contingencies</li>
            <li>In charge of evaluating the initiatives and operations in the Communications Cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul>
        
        <h2><b>eServices Associate Seretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the eServices Cluster as their intermediary</li>
            <li>Takes the minutes of the meeting of the eServices Cluster BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the eServices Cluster, and reports any violation thereof</li>
            <li>Ensures proper documentation of the eServices Cluster’s procedures and helps the eServices VP in dealing with contingencies</li>
            <li>In charge of evaluating the initiatives and operations in the Communications Cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul>

        <h2><b>Events Associate Seretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the Events Cluster as their intermediary</li>
            <li>Takes the minutes of the meeting of the Events Cluster BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the Events Cluster, and reports any violation thereof</li>
            <li>Ensures proper documentation of the Events Cluster’s procedures and helps the Events VP in dealing with contingencies</li>
            <li>In charge of evaluating the initiatives and operations in the Communications Cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul>
        
        <h2><b>Human Resources Associate Seretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the Human Resources Cluster as their intermediary</li>
            <li>Takes the minutes of the meeting of the Human Resources Cluster BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the Human Resources Cluster, and reports any violation thereof</li>
            <li>Ensures proper documentation of the Human Resources Cluster’s procedures and helps the Human Resources VP in dealing with contingencies</li>
            <li>In charge of evaluating the initiatives and operations in the Communications Cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul>

        <h2><b>Marketing Associate Seretary-General (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Under both the OSG and the Marketing Cluster as their intermediary</li>
            <li>Takes the minutes of the meeting of the Marketing Cluster BETA</li>
            <li>Enforces the observance of the codes and protocols of the organization by the Marketing Cluster, and reports any violation thereof</li>
            <li>Evaluates the cluster based on given metrics or key performance indicators (KPIs)</li>
            <li>Ensures proper documentation of the Marketing Cluster’s procedures and helps the Marketing VP in dealing with contingencies</li>
            <li>In charge of overseeing the operations and handling the organizational development initiatives in the Marketing Cluster</li>
            <li>Trains, oversees, and communicates with their assigned OSG officer, and serves as the bridge between them and the Office of the Secretary General</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerOSG'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>
